<template>
  <v-main>
    <v-container class="fill-height" fluid>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="8" md="4">
          
          
          
          <v-card v-if="checkConnection" class="elevation-12">
            <v-toolbar color="primary" dark flat>
              <v-toolbar-title>{{ $t("LoginForm.FormTopic") }}</v-toolbar-title>
              <v-spacer />
            </v-toolbar>
            <v-card-text>
              <v-form ref="loginForm" @keyup.native.enter="BtnSendLogin" >
               
                <v-text-field
                 
                  label="Login"
                  prepend-icon="mdi-account"
                  v-model="login"
                  id="login"
                  name="login"
                  required

            
                ></v-text-field>
                <v-text-field
                  :label="label_password"
                  prepend-icon="mdi-lock-outline"
                  v-model="password"
                  id="password"
                  name="password"
                  type="password"
                  autocomplete="on"
                  required
                
                ></v-text-field>
              </v-form>
            </v-card-text>

            <v-card-actions>
              <v-btn text small @click="ButResetPassword">{{
                $t("LoginForm.ResetPassword")
              }}</v-btn>
              <v-spacer />
              <v-btn
                v-if="valid"
                color="primary"
                @click="BtnSendLogin"
                :loading="loadingBtn"
                >{{ $t("LoginForm.Login") }}</v-btn
              >
            </v-card-actions>

            <v-dialog v-model="dialogResetPassword" max-width="400">
              <v-card>
                <v-card-title class="headline">{{
                  $t("LoginForm.ResetPassword")
                }}</v-card-title>
                <v-card-text>
                  <v-form ref="loginForm">
                    <v-text-field
                    v-model="loginReset"
                      id="loginReset"
                      name="loginReset"
                      label="Login"
                      prepend-icon="mdi-login"
                      required
                    ></v-text-field>
                  </v-form>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn text color="error" @click="dialogResetPassword = false">{{
                    $t("Close")
                  }}</v-btn>
                  <v-btn 
                    
                    text color="primary" 
                    @click="BtnSendPasswordReset">{{
                    $t("Send")
                  }}
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <v-dialog v-model="dialogLoginError" max-width="290">
              <v-card>
                <v-card-title class="headline">{{
                  $t("LoginForm.FormErrorTopic")
                }}</v-card-title>
                <v-card-text>{{ $t("LoginForm.LoginError") }}</v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="blue darken-1"
                    text
                    @click="dialogLoginError = false"
                    >{{ $t("Close") }}</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-snackbar v-model="snack" :timeout="2000" :color="snackColor">
            {{ snackText }}
            <v-btn text @click="snack = false">Close</v-btn>
            </v-snackbar>
          </v-card>
          
          <v-card v-else class="elevation-12">
            <v-toolbar color="red" dark flat >
              <v-spacer>
              <v-toolbar-title  class="flex text-center">{{ $t("LoginForm.ServiceWork") }}</v-toolbar-title>
              </v-spacer>
            </v-toolbar>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>

export default {
  data: () => ({
    
    checkConnection: true,
    snack: false,
    snackColor: "",
    snackText: "",
    
    valid: true,
    loadingBtn: false,
    dialogResetPassword: false,
    dialogLoginError: false,
    login: "",
    password: "",
    loginReset: "",
    country: "",
    menu: ""
  }),

  methods: {
    async chceckAPIConnection() {
      await window.Store.dispatch("chceckAPIConnection")
        .then(response => {
          this.checkConnection = true;
          this.Answer = response;
        })
        .catch(errors => {
          this.Answer = errors;
          this.checkConnection = false;
        });
    },
    async BtnSendLogin() {
      this.loadingBtn = true;
      const LoginData = {
        login: this.login,
        password: this.password
      };

      await window.Store.dispatch("login", LoginData)
        .then(response => {
          if (window.Store.getters.getAuthoriseResult=="logged") {
            this.$router.push("/");
            this.loadingBtn = false;
          } else {
            this.loadingBtn = false;
            this.dialogLoginError = true;
          }
          this.Answer = response;
        })
        .catch(errors => {
          this.Answer = errors;
          this.loadingBtn = false;
          this.dialogLoginError = true;
        });
    },
    async BtnSendPasswordReset() {
      this.loadingBtn = true;

      if (this.$cookies.isKey("TPLanguage") == true) {
       this.country = this.$cookies.get("TPLanguage");
      } else {
        this.country = navigator.language.substr(0, 2);
      }

      const LoginResetData = {
        loginReset: this.loginReset,       
        country: this.country 
      };
    
      await window.Store.dispatch("forgottenPassword", LoginResetData)
        .then(response => {
          this.snack = true;
          this.snackColor = "success";
          this.snackText = "Link resetujący hasło został wysłany na maila"; this.dialogResetPassword = false;
          this.Answer = response;
          this.loadingBtn = false;
          setTimeout( () => this.$router.push({ path: '/'}), 3000);
          
        })
        .catch(errors => {
          this.snack = true;
          this.snackColor = "error";
          this.snackText = "Bląd podczas zmieniania hasła";
          this.dialogResetPassword = false;
          this.Answer = errors;
          this.loadingBtn = false;
        });
    },
    ButResetPassword: function() {
      this.dialogResetPassword = true;
    }
    
  },
  async mounted()  {
     //await this.chceckAPIConnection();
  },
  computed: {
    label_password: function() {
      return this.$t("LoginForm.Password");
    }
  }
  

};
</script>
